const compareIgnoreCase = (valueA, valueB) => {
  if (!valueA && !valueB) return 0;
  else if (valueA && !valueB) return -1;
  else if (!valueA && valueB) return 1;
  else return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};

export default compareIgnoreCase;
